var percentColors = {
  97: '#108638',
  80: '#F5D410',
  0: 'red',
  'On Time': '#108638',
  'Delayed': '#F5D410',
};


export const percentColor = percentage => {
  var colorKey = Object.keys(percentColors).sortDesc().find(f => f <= parseFloat(percentage)) || percentage;
  return percentColors[colorKey];
};

export const percentStyle = percentage => {
  var backgroundColor = percentColor(percentage);
  return {
    color: backgroundColor === '#108638' ? 'white' : 'black',
    backgroundColor,
  }
};
